export default class CreateAsignacionEquipo {
  #repository
  constructor(repository) {
    this.#repository = repository
  }
  async execute(idSubSede, payload) {
    try {
      const result = await this.#repository.createAsignacion(idSubSede, payload)
      return result
    } catch (error) {
      console.error('Error al crear la asignación de equipo:', error)
      throw error
    }
  }
}
